import Window from "../../components/Window";
import Button from "../../widgets/Button";

import SelectBar from "../../components/SelectBar";
import {
  ClockCircleOutlined,
  FieldTimeOutlined,
  BellOutlined,
  BellFilled,
  PlusOutlined,
  CaretRightOutlined,
  RollbackOutlined,
  PauseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import styles from "./styles.jsx";
import "react-clock/dist/Clock.css";
import { useEffect, useState } from "react";
import { formatDate } from "../../utils.js";
import { themeColors } from "../../config.js";
import { TimePicker } from "antd";
import moment from "moment";

const ClockModes = {
  CLOCK: 0,
  TIMER: 1,
  ALARM: 2,
};

export const OptionBtn = ({ text, icon, onClick }) => {
  return (
    <Button style={styles.optionBtn} onClick={onClick}>
      {icon}
      {text}
    </Button>
  );
};

const ClockComp = ({ clockIndex, setClockIndex, clocks, time, refresh }) => {
  const timeString =
    formatDate(time).hour +
    ":" +
    formatDate(time).minute +
    ":" +
    formatDate(time).second;
  useEffect(refresh, []);
  return (
    <div style={{ ...styles.full, minHeight: 300 }}>
      {clocks[clockIndex]}
      <SelectBar
        index={clockIndex}
        length={clocks.length}
        selectIndex={setClockIndex}
        radius={5}
      />
      <div
        style={{
          color: themeColors.optionTextColor,
          padding: 10,
          fontWeight: "bold",
        }}
      >
        {timeString}
      </div>
    </div>
  );
};

const TimerComp = ({
  timer,
  startDate,
  timerVal,
  setStartDate,
  setTimerVal,
}) => {
  const getTimerString = (delta) => {
    const hours = Math.floor((delta / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((delta / 1000 / 60) % 60);
    const secs = Math.floor((delta / 1000) % 60);
    const msecs = Math.floor((delta % 1000) / 10);
    return (
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (mins < 10 ? "0" + mins : mins) +
      ":" +
      (secs < 10 ? "0" + secs : secs) +
      ":" +
      (msecs < 10 ? "0" + msecs : msecs)
    );
  };

  return (
    <div style={styles.full}>
      <div
        style={{
          color: themeColors.optionTextColor,
          padding: 10,
          fontWeight: "bold",
          fontSize: 20,
          width: 150,
        }}
      >
        {getTimerString(timerVal)}
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Button
          style={{ margin: 5, backgroundColor: themeColors.red }}
          onClick={() => {
            if (startDate === null) {
              const newDate = new Date();
              setStartDate(newDate);
              if (!timer.current)
                timer.current = setInterval(() => {
                  const delta = new Date() - newDate + timerVal;
                  setTimerVal(delta);
                }, 16);
            } else {
              setStartDate(null);
              clearInterval(timer.current);
              timer.current = null;
            }
          }}
        >
          {startDate === null ? <CaretRightOutlined /> : <PauseOutlined />}
        </Button>
        <Button
          style={{ margin: 5 }}
          onClick={() => {
            setStartDate(null);
            clearInterval(timer.current);
            timer.current = null;
            setTimerVal(0);
          }}
        >
          <RollbackOutlined />
        </Button>
      </div>
    </div>
  );
};

const AlarmComp = ({ systemData, updateSystemData }) => {
  const [time, setTime] = useState(null);
  const alarmObj = systemData
    ? systemData.alarm
      ? systemData.alarm
      : { alarmList: [] }
    : { alarmList: [] };
  const alarmList = alarmObj ? alarmObj.alarmList : [];
  const alarmEntries = alarmList.map((alarm, index) => {
    return (
      <div
        key={index}
        style={{ ...styles.alarmRow, opacity: alarm.disabled ? 0.5 : 1 }}
      >
        <div style={styles.alarmText}>{moment(alarm.time).format("HH:mm")}</div>
        <div style={styles.alarmBtn}>
          <Button
            style={{ margin: 5 }}
            onClick={() => {
              toggleAlarmDisabled(index);
            }}
          >
            {alarm.disabled ? <BellOutlined /> : <BellFilled />}
          </Button>
          <Button
            style={{ margin: 5, backgroundColor: themeColors.red }}
            onClick={() => {
              deleteAlarm(index);
            }}
          >
            <DeleteOutlined />
          </Button>
        </div>
      </div>
    );
  });
  const toggleAlarmDisabled = (index) => {
    const newAlarmList = [...alarmObj.alarmList];
    newAlarmList[index].disabled = !newAlarmList[index].disabled;
    updateSystemData({
      alarm: {
        ...alarmObj,
        alarmList: newAlarmList,
      },
    });
  };
  const deleteAlarm = (index) => {
    const newAlarmList = [...alarmObj.alarmList];
    newAlarmList.splice(index, 1);
    updateSystemData({
      alarm: {
        ...alarmObj,
        alarmList: newAlarmList,
      },
    });
  };
  const addAlarm = () => {
    const newAlarmList = [...alarmObj.alarmList];
    newAlarmList.push({ time: new Date(time), disabled: false });
    updateSystemData({
      alarm: {
        ...alarmObj,
        alarmList: newAlarmList,
      },
    });
  };
  return (
    <div style={{ ...styles.full, justifyContent: "flex-start" }}>
      {alarmEntries}
      <div style={{ ...styles.alarmRow, justifyContent: "center" }}>
        <TimePicker
          value={time}
          onChange={setTime}
          format={"HH:mm"}
          size={"small"}
        />
        <Button
          style={{ margin: 10, backgroundColor: themeColors.green }}
          onClick={addAlarm}
        >
          <PlusOutlined />
        </Button>
      </div>
    </div>
  );
};

const ClockApp = ({
  setOpen,
  timer,
  timerVal,
  setTimerVal,
  startDate,
  setStartDate,
  systemData,
  updateSystemData,
  time,
  clockIndex,
  setClockIndex,
  clocks,
  refresh,
}) => {
  const [clockMode, setClockMode] = useState(ClockModes.CLOCK);
  const component =
    clockMode === ClockModes.CLOCK ? (
      <ClockComp
        systemData={systemData}
        updateSystemData={updateSystemData}
        clockIndex={clockIndex}
        setClockIndex={setClockIndex}
        clocks={clocks}
        time={time}
        refresh={refresh}
      />
    ) : clockMode === ClockModes.TIMER ? (
      <TimerComp
        timer={timer}
        timerVal={timerVal}
        setTimerVal={setTimerVal}
        startDate={startDate}
        setStartDate={setStartDate}
      />
    ) : (
      <AlarmComp systemData={systemData} updateSystemData={updateSystemData} />
    );
  return (
    <Window
      id={"clock"}
      top={0}
      left={0}
      name={"Clock"}
      onCancel={() => setOpen(false)}
    >
      <div style={styles.component}>{component}</div>
      <div style={styles.manuBar}>
        <OptionBtn
          text="clock"
          onClick={() => setClockMode(ClockModes.CLOCK)}
          icon={<ClockCircleOutlined style={{ fontSize: 20, margin: 5 }} />}
        />
        <OptionBtn
          text="timer"
          onClick={() => setClockMode(ClockModes.TIMER)}
          icon={<FieldTimeOutlined style={{ fontSize: 20, margin: 5 }} />}
        />
        <OptionBtn
          text="alarm"
          onClick={() => setClockMode(ClockModes.ALARM)}
          icon={<BellOutlined style={{ fontSize: 20, margin: 5 }} />}
        />
      </div>
    </Window>
  );
};

export default ClockApp;
